import styled from 'styled-components'
import { Route, Navigate, Routes as Switch } from 'react-router-dom'

// import { GamePage } from 'components/pages/games'
import { GamePageV3 } from 'components/pages/gamesV3'
// import { Leaderboard } from 'components/pages/leaderboard'
// import { LiquidityDashboardPage } from 'components/pages/liquidityDashboard'
// import { BidderDashboardPage } from 'components/pages/bidderDashboard'
// import { YoloXftPage } from 'components/pages/yoloXftPage'
// import { WalletPage } from 'components/pages/wallet'

//Updaters
// import { TransactionsUpdater } from 'redux/slices/wallet/Updaters/Transactions.updater'
// import { YlpRewardBalanceUpdater } from 'hooks/ylp/useYlpRewardBalance'
// import { UnclaimedBalanceUpdater } from 'hooks/unclaimedEarning/useUnclaimedBalance'
import { OnLoad } from './OnLoad'

//Observer
import { useUserObserver } from 'hooks/user/useUserObserver'
import { useLvgOrderObserver } from 'hooks/games/lvg/useLvgOrders'

//Others
import { config } from 'config'
import { ToastContainer } from 'lib/yoloToasts/ToastsContainer'
import { ModalContainer } from 'lib/yoloModals/ModalContainer'
import { useSocket } from 'hooks/sockets/useSocket'
import { RedditLink } from 'components/pages/RedditLink'

// Admins Banners
import { RestrictedBanner } from './RestrictedBanner'
import { YoloBot } from 'yolobot'
import { YoloBotGraph } from 'yolobot/graph'
import { CONTENT_TYPES } from 'constants/games/contentTypes'
// import { useLvgYourOrderObserver } from 'hooks/games/lvg/useYourBidsOrders'
import { TgWebAppWrapper } from 'lib/tgWebApp/TgWebAppWrapper'
import { YBotIpCheck } from 'components/pages/yolobot/YBotIpCheck'
import { UserMobileFlow } from 'components/pages/UserMobileFlow'

const { GATEWAY_SOCKET_URL, BACKEND_SOCKET_URL } = config

const MainWrapper = styled.div`
  position: relative;
  height: 100%;
  display: grid;
  grid-template:
    'content' 1fr
    /1fr;
  justify-items: stretch;
`

export const Routes = () => {
  useSocket('priceFeed', BACKEND_SOCKET_URL)
  return (
    <>
      <ToastContainer />
      <ModalContainer />
      <OnLoad />
      <MainWrapper>
        <Switch>
          <Route exact path='/yolobot/register/:referralcode' element={<YoloBot />} />
          <Route exact path='/yolobot/graph' element={<YoloBotGraph />} />
            <Route path='yolobot' element={<TgWebAppWrapper />} >
              <Route index element={<YoloBot />} />
              <Route path='ipcheck/:action' element={<YBotIpCheck />} />
            </Route>
            {/* <Route path='/yolobot/' element={<YoloBot />} /> */}
            <Route path='/mobile-notifications' element={<UserMobileFlow />} />
            <Route path='/game/*' element={<GameV3Routes />} />
          {/* Start -  Influencer short urls */}
          <Route path='/wiz' element={<Navigate to='/game/private_presale/wiz' />} />
          <Route path='/defi_brian' element={<Navigate to='/game/private_presale/defi_brian' />} />
          <Route path='/aditya' element={<Navigate to='/game/private_presale/aditya' />} />
          <Route path='/mike' element={<Navigate to='/game/private_presale/mike' />} />
          <Route path='/hoss' element={<Navigate to='/game/private_presale/hoss' />} />
          {/* End -  Influencer short urls */}

          <Route path='/presale' element={<Navigate to='/game/public_presale' />} />
          <Route path='*' element={<Navigate to='/game' replace />} />
        </Switch>
      </MainWrapper>
      <RestrictedBanner />
    </>
  )
}

const GameV3Routes = (props) => {
  // const { path } = useRouteMatch()
  //SocketConnections
  useSocket('gateway', GATEWAY_SOCKET_URL)

  //Observers
  useUserObserver()
  useLvgOrderObserver()
  // useLvgYourOrderObserver()

  return (
    <>
      <Switch>
        <Route path='/reddit/link' element={<RedditLink />} />
        <Route
          path='/private_presale/9a4c6a5f-f1e5-42be-a583-4131c9e5d65c'
          element={<GamePageV3 contentProp='private_presale' />}
        />
        <Route path='/private_presale/:influencer' element={<GamePageV3 contentProp='private_presale' />} />

        {/* public_presale */}
        <Route path='/public_presale' element={<GamePageV3 contentProp={CONTENT_TYPES.PUBLIC_PRESALE} />} />
        <Route path='/public_presale/:influencer' element={<GamePageV3 contentProp={CONTENT_TYPES.PUBLIC_PRESALE} />} />
        {/* public_presale */}

        <Route path='/:content' element={<GamePageV3 />} />
        <Route path='/' element={<GamePageV3 />} />
        <Route path='*' element={<Navigate to='' replace />} />
      </Switch>
    </>
  )
}
